// ── Tipos ──

export interface PaletaColores {
  primary900: string;
  primary800: string;
  primary700: string;
  primary600: string;
  primary500: string;
  primary200: string;
  primary100: string;
  primary50: string;
}

export interface PaletaDefinicion {
  name: string;
  colors: PaletaColores;
}

export interface Neutros {
  background: string;
  surface: string;
  text: string;
  muted: string;
  border: string;
  white: string;
}

export interface Semanticos {
  success: string;
  error: string;
  warning: string;
}

export interface PaletasConfig {
  palettes: Record<string, PaletaDefinicion>;
  neutral: Neutros;
  semantic: Semanticos;
}

// ── Datos ──

export const PALETAS: PaletasConfig = {
  palettes: {
    blue: {
      name: 'Azul',
      colors: {
        primary900: '#0B2C47', primary800: '#143F64', primary700: '#1B5484',
        primary600: '#226AA4', primary500: '#2F83C5', primary200: '#B3D5EF',
        primary100: '#D8EAF7', primary50: '#EEF6FC'
      }
    },
    green: {
      name: 'Verde',
      colors: {
        primary900: '#0B3025', primary800: '#164836', primary700: '#216447',
        primary600: '#2E7D58', primary500: '#3F966B', primary200: '#AFDCC2',
        primary100: '#D8EFE2', primary50: '#EFF8F3'
      }
    },
    purple: {
      name: 'Morado',
      colors: {
        primary900: '#271B3F', primary800: '#3B285B', primary700: '#50377A',
        primary600: '#66479B', primary500: '#7B5BB3', primary200: '#CBB7E5',
        primary100: '#E6DCF4', primary50: '#F4F0FA'
      }
    },
    garnet: {
      name: 'Granate',
      colors: {
        primary900: '#3A1420', primary800: '#571F2E', primary700: '#762B3E',
        primary600: '#94384E', primary500: '#B14A62', primary200: '#E5B1BE',
        primary100: '#F2D8DE', primary50: '#FBF0F2'
      }
    },
    amber: {
      name: 'Ámbar',
      colors: {
        primary900: '#3F2A0D', primary800: '#5F3F14', primary700: '#855A1B',
        primary600: '#A87522', primary500: '#C8932F', primary200: '#F6D28C',
        primary100: '#FCEBC5', primary50: '#FFF8EA'
      }
    },
    cian: {
      name: 'Cian',
      colors: {
        primary900: '#07343D', primary800: '#0B4A55', primary700: '#106471',
        primary600: '#178091', primary500: '#22A0B3', primary200: '#A8E0E7',
        primary100: '#D5F1F4', primary50: '#ECFAFB',
      }
    }
  },
  neutral: {
    background: '#F6F8F7',
    surface: '#FFFFFF',
    text: '#1F2926',
    muted: '#60706A',
    border: '#DDE5E1',
    white: '#FFFFFF'
  },
  semantic: {
    success: '#16A34A',
    error: '#DC2626',
    warning: '#F59E0B'
  }
};